import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TrigerToastService } from '../../services/triger-toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ToastModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  providers: [MessageService],
})
export class ToastComponent {
  toastMessage: any;
  constructor(
    private messageService: MessageService,
    private toastS: TrigerToastService
  ) {}

  ngOnInit(): void {
    this.toastS.getToastMessage().subscribe((res: any) => {
      this.toastMessage = res;
      if (res && res.type && res.shortMessage) {
        this.showToast(
          this.toastMessage.type,
          this.toastMessage.shortMessage,
          this.setMessage(this.toastMessage)
        );
      }
    });
  }

  showToast(severity: any, summary: any, detail: any) {
    this.messageService.add({
      severity: severity,
      summary: summary,
      detail: detail,
    });
  }

  setMessage(data: any) {
    let retVal: any = data.Message;
    if (!data.Message || data.Message.length < 1) {
      if (data.type === 'success') {
        retVal = 'Success!';
      } 
    }
    return retVal;
  }
}
